import * as React from "react";
import { Lambda, observe } from "mobx";
import { YourbetMiniBetSlipData } from "../../data";

interface StakeInputProps {
    provider: YourbetMiniBetSlipData
    handler: Function
}

export class StakeInput extends React.Component<StakeInputProps, {
    value: string
}> {
    disposeValue: Lambda

    constructor(props: StakeInputProps) {
        super(props);
        this.state = {
            value: props.provider.stakeValue
        };
        this.disposeValue = observe(this.props.provider, "stakeValue", o => {
            this.setState({
                value: o.newValue
            });
        });
    }

    componentWillUnmount() {
        this.disposeValue();
    }

    getInputValue = e => {
        this.setState({
            value: e.target.value
        }, () => {
            this.props.handler(this.state.value);
        });
    }

    render() {
        return (
            <input
                type="number"
                className="rj-yourbet__stake-input"
                data-uat="rj-yourbet-stake-input"
                value={this.state.value}
                onChange={this.getInputValue} />
        );
    }
}